import SectionTitle from "../../../components/SectionTitle/SectionTitle";
import "./ContactBanner.css";
import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context/AppState/AppContext";

const ContactBanner = () => {
  const {jsonTexts, jsonMedia} = useAppContext();
  const {title, subtitleTag, buttonTitle} = jsonTexts.inicio.contactBanner;

  const {contactBannerImage} = jsonMedia?.inicio

  const navigate = useNavigate();
  const onClickHandle = () => {
    navigate("/contacto");
  };
  return (
    <div className="contactBanner-father-div">
      <div className="contactBanner-info-container">
        <div className="contactBanner-title-container">
          <SectionTitle
            upText={subtitleTag}
            downText={title}
          />
        </div>
        <div className="contactBanner-button-div">
          <Button
            onClick={onClickHandle}
            
            fullWidth
            color="var(--color-tertiary)"
          >
            {buttonTitle}
          </Button>
        </div>
      </div>
      <div className="contactBanner-image-div-container">
        <img
         alt="ilustración"
          className="contactBanner-image-div-styling"
          src={contactBannerImage}
        />
      </div>
    </div>
  );
};
export default ContactBanner;
